// extracted by mini-css-extract-plugin
module.exports = {"text":"Terms_text__2Hcrl","approveText":"Terms_approveText__3ANX5"};